import { IBaseConfig } from "@models/form/base-config";
import { PathIcons } from "@static/icons/path-icons";
import { HardFormFieldTypeEnum, IHardFormField } from "@hardcode-kz/ui";

export class BaseGridWidgetConfig implements IBaseConfig {
  version = 1;

  fields: IHardFormField<any>[] = [
    {
      name: "title",
      type: HardFormFieldTypeEnum.Input,
      title: "Заголовок",
    },
    {
      name: "subTitle",
      type: HardFormFieldTypeEnum.Input,
      title: "Подзаголовок",
    },
    {
      name: "icon",
      type: HardFormFieldTypeEnum.Icon,
      title: "base.icon",
      params: {
        dicType: PathIcons,
      },
    },
  ];
}
